import { useEffect, useState } from "react";

/** True when `document.body` has the `dark-mode` class (navbar toggle). */
export function useBodyDarkMode(): boolean {
  const [dark, setDark] = useState(
    () =>
      typeof document !== "undefined" &&
      document.body.classList.contains("dark-mode")
  );
  useEffect(() => {
    const el = document.body;
    const obs = new MutationObserver(() => {
      setDark(el.classList.contains("dark-mode"));
    });
    obs.observe(el, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);
  return dark;
}
